// features/auth/authApi.js
import axios from "../../api/axiosInstance";

// User registration
export const signup = (userData) => axios.post("/user", userData);

// Username/password login
export const signin = (credentials) => axios.post("/login", credentials);

// ✅ Get current logged-in user (Google session or existing cookie)
export const getCurrentUser = async () => {
  try {
    const response = await axios.get("/me", {
      withCredentials: true, // 👈 important for FastAPI sessions
    });
    return response.data;
  } catch (err) {
    if (err.response?.status === 401) {
      // ℹ️ 401 is expected for guest users (not logged in). No need to log as error.
      return null;
    }
    console.error("❌ Failed to fetch current user:", err);
    return null;
  }
};

export const logout = async () => {
  try {
    await axios.get("/auth/logout", { withCredentials: true });
  } catch (err) {
    console.error("❌ Logout request failed:", err);
  }
};

